import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Box, Button, Label, Input } from '@theme-ui/components';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`The Future Economies Reading Group is meeting monthly through 2021.`}</h1>
    <p>{`We will discuss topics including:`}</p>
    <ul>
      <li parentName="ul">{`Worker-owned cooperatives`}</li>
      <li parentName="ul">{`Worker self-directed non-profits`}</li>
      <li parentName="ul">{`Platform cooperatives`}</li>
      <li parentName="ul">{`Legislative efforts like the CA Cooperative Economy Act`}</li>
      <li parentName="ul">{`Commons-based peer production`}</li>
      <li parentName="ul">{`Community development financial institutions`}</li>
    </ul>
    <Box as='form' action="https://formspree.io/f/mnqogeqr" method="POST" mdxType="Box">
  <Input placeholder="Sign up by email" style={{
        display: 'inline',
        maxWidth: '280px',
        marginRight: '8px',
        marginBottom: '8px'
      }} type="email" name="email" mdxType="Input" />
  <Button style={{
        backgroundColor: 'black'
      }} mdxType="Button">Sign up</Button>
    </Box>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      